import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/hooks";
import { Formik } from "formik";
import * as Yup from "yup";

import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import { postCreateDevice } from "../../../redux/api/admin.api";

import ContentCard from "../../../components/misc/ContentCard";
import TextInput from "../../../components/misc/TextInput";
import CustomButton from "../../../components/CustomButton";

interface InitialValues {
  model: string | null;
  sn: string | null;
  mac: string | null;
  indicativ: string | null;
  observatii: string | null;
}

const initialValues: InitialValues = {
  model: null,
  sn: null,
  mac: null,
  indicativ: null,
  observatii: null,
};

const schema = Yup.object({
  model: Yup.string().nullable().required("Campul este obligatoriu"),
  sn: Yup.string().nullable().required("Campul este obligatoriu"),
  mac: Yup.string().nullable().required("Campul este obligatoriu"),
  indicativ: Yup.string().nullable().required("Campul este obligatoriu"),
  observatii: Yup.string().nullable(),
});

function CreateDevice() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const handleGoBack = () => navigate(-1);

  const handleSave = async (values: InitialValues) => {
    const payload = {
      model: values.model,
      sn: values.sn,
      mac: values.mac,
      indicativ: values.indicativ,
      observatii: values.observatii,
    };

    setIsLoading(true);
    const result = await dispatch(postCreateDevice({ params: payload }));

    if (
      checkEndpointStatus(result, postCreateDevice) !== endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(result, postCreateDevice) === endpointStatus.fulfilled
    ) {
      handleGoBack();
    }
  };

  return (
    <ContentCard cardTitle="Creează echipament">
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleSave}>
        {({
          isValid,
          errors,
          touched,
          getFieldProps,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit} noValidate>
            <div className="flex">
              <TextInput
                className="mb-4 mr-2"
                label="Model"
                name="model"
                error={errors["model"]}
                touched={touched["model"]}
                inputProps={getFieldProps("model")}
              />
              <TextInput
                className="mb-4 mr-2"
                label="SN"
                name="sn"
                error={errors["sn"]}
                touched={touched["sn"]}
                inputProps={getFieldProps("sn")}
              />
              <TextInput
                className="mb-4 mr-2"
                label="MAC"
                name="mac"
                error={errors["mac"]}
                touched={touched["mac"]}
                inputProps={getFieldProps("mac")}
              />
              <TextInput
                className="mb-4 mr-2"
                label="Indicativ"
                name="indicativ"
                error={errors["indicativ"]}
                touched={touched["indicativ"]}
                inputProps={getFieldProps("indicativ")}
              />
            </div>

            <div className="flex">
              <TextInput
                className="mb-4 mr-2 flex-grow"
                label="Observații"
                name="observatii"
                type="textarea"
                error={errors["observatii"]}
                touched={touched["observatii"]}
                inputProps={getFieldProps("observatii")}
              />
            </div>

            <div className="flex justify-between">
              <CustomButton variant="outlined" onClick={handleGoBack}>
                Anulează
              </CustomButton>
              <CustomButton
                type="submit"
                variant="contained"
                loading={isSubmitting || isLoading}
                disabled={!isValid || isSubmitting}>
                Salvează
              </CustomButton>
            </div>
          </form>
        )}
      </Formik>
    </ContentCard>
  );
}

export default CreateDevice;
